<template>
    <transition name="van-fade">
        <div v-show="show" class="back">
            <div v-if="toastRow.selId == 1" class="oneIDiv backColor" style="">
                <div style="padding:15px 20px">
                    <div class="title">{{toastRow.title}}</div>
                    <div class="titleText" style="padding: 7px 5%;">{{toastRow.text}}</div>
                </div>
                <!-- <div class="querenBu borderTOP" style="">
                    知道了
                </div> -->
            </div>
            <div v-if="toastRow.selId == 2" class="oneIDiv backColor" style="">
                <div style="padding:15px 20px">
                    <div class="title">welcome</div>
                    <div class="titleText" style="padding: 7px 5%;">欢迎使用发达发顺丰是飞洒发士大夫</div>
                </div>
                <div class="borderTOP" style="display:flex;flex-direction:row">
                    <div style="width:49%;" class="cacelBu">
                        关闭
                    </div>
                    <div style="width:2%;display: flex;justify-content: center;">
                        <div style="" class="centerBorder"></div>
                    </div>
                    <div style="width:49%" class="querenBu">
                        重试
                    </div>
                </div>
            </div>
            <div v-if="toastRow.selId == 3" class="cDiv" style="text-align:center">
                <!-- <div class="one" style="text-align: center;padding: 25px 0px;"> -->
                <img src="./image/success.png" alt="" style="width: 35%;padding-top: 25px;">
                <!-- </div> -->
                <div class="title">{{toastRow.title}}</div>
                <div class="titleText" style="padding: 7px 5% 25px 5%;display:none">{{toastRow.text}}</div>
                <!-- <div class="querenBu borderTOP" style="">
                确定
            </div> -->
            </div>
            <div v-if="toastRow.selId == 4" class="cDiv" style="text-align:center">
                <!-- <div class="one" style="text-align: center;padding: 25px 0px;"> -->
                <img src="./image/error.png" alt="" style="width: 35%;padding-top: 25px;">
                <!-- </div> -->
                <div class="title">{{toastRow.title}}</div>
                <div class="titleText" style="padding: 7px 5% 25px 5%;display:none">{{toastRow.text}}</div>
                <!-- <div class="querenBu borderTOP" style="">
                    确定
                </div> -->
            </div>
            <div v-if="toastRow.selId == 5" class="cDiv" style="text-align:center">
                <!-- <div class="one" style="text-align: center;padding: 25px 0px;"> -->
                <img src="./image/fail.png" alt="" style="width: 35%;padding-top: 25px;">
                <!-- </div> -->
                <div class="title">{{toastRow.title}}</div>
                <div class="titleText" style="padding: 7px 5% 25px 5%;display:none">{{toastRow.text}}</div>
                <!-- <div class="querenBu borderTOP" style="">
                    确定
                </div> -->
            </div>
        </div>
    </transition>
</template>
<script>
export default {
    name: "toast",
    props: ["toastRow", "show"],
    watch: {
        show(newVal, oldVal) {
            if (newVal) {
                setTimeout(() => {
                    this.show = false;
                }, 1500);
            }
        },
    },
    methods: {},
};
</script>
<style>
.back {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 2003;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
}
.centerBorder {
    border-left: 0.5px solid rgb(220, 222, 227);
    height: calc(100% - 2px);
    width: 0px;
}
.backColor {
    background-color: white;
    width: 70%;
    border-radius: 10px;
}
.title {
    font-size: 20px !important;
    text-align: center;
    padding: 0 5%;
    padding-bottom: 20px;
}
.titleText {
    color: rgba(136, 136, 136, 1);
    font-size: 20px;
    text-align: center;
}
.cacelBu {
    color: black;
    font-size: 20px;
    text-align: center;
    padding: 16px 0;
}
.querenBu {
    color: rgba(16, 142, 233, 1);
    font-size: 20px;
    text-align: center;
    padding: 16px 0;
}
.borderTOP {
    border-top: 1px solid rgba(220, 222, 227);
}
.cDiv {
    /* height: 40vh; */
    width: 45% !important;
    background-color: #fff;
    border-radius: 10px;
}
.closeIMg {
    height: 3vh;
}
.one {
    height: 12vh;
}
.two {
    height: 7vh;
}
.three {
    height: 7vh;
}
.four {
    height: 11vh;
}
</style>
